import buildAutomaticNotificationRows from './buildAutomaticNotificationRows'
import buildNotificationRows from './buildNotificationRows'
import diffAndBuildPayload from './diffAndBuildPayload'
import formatData from './formatData'
import resolveCurrentColumn from './resolveCurrentColumn'
import status from './status'
import statusChipColor from './statusChipColor'

const activities = {
  buildAutomaticNotificationRows,
  buildNotificationRows,
  diffAndBuildPayload,
  formatData,
  resolveCurrentColumn,
  status,
  statusChipColor,
}

export default activities
